import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environment';


export interface CreateLeadRequest {
  [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class PartnerService {
  private readonly baseUrl = environment.partnerApi.baseUrl;
  private readonly apiKey = environment.partnerApi.apiKey;

  constructor(private http: HttpClient) { }

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'apikey': this.apiKey,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    });
  }

  checkEligibility(mobileNumber: string): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/partner/dedupe`,
      { mobileNumber },
      { headers: this.getHeaders() }
    );
  }

  createLead(data: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/v2/partner/create-lead`,
      data,
      { headers: this.getHeaders() }
    );
  }

  updateLead(leadId: string, data: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/v2/partner/update-lead/${leadId}`,
      data,
      { headers: this.getHeaders() }
    );
  }

  getOffers(leadId: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/partner/get-offers/${leadId}`,
      { headers: this.getHeaders() }
    );
  }

  getSummary(leadId: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/partner/get-summary/${leadId}`,
      { headers: this.getHeaders() }
    );
  }

  applyGoldLoan(data: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/v2/partner/gold-loans`,
      data,
      { headers: this.getHeaders() }
    );
  }

  applyHousingLoan(data: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/v2/partner/housing-loan`,
      data,
      { headers: this.getHeaders() }
    );
  }
}
